import { FaChartBar, FaUser } from "react-icons/fa";
import { FaSignOutAlt } from 'react-icons/fa';
import { Link, NavLink } from "react-router-dom";
export function MenuBar() {
const active={
  backgroundColor:'red'
}

  return (
    <div className="SideBarMenu">
      <ul>
        <div className='menu'>
          <li >
          <NavLink to="/report"  activeClassName='active' >
            <FaChartBar className='menuIcon' />{" "} <span className="menuText">Dashboard</span>
            </NavLink>
          </li>
          <li className='profileMenu' >
          <NavLink to="/profile" activeClassName='active'>
          <FaUser className='menuIcon' /> <span className="menuText">Profile</span>
            </NavLink>
          </li>
          <li className='profileMenu' onClick={() => {
            localStorage.removeItem('login_id');
            window.location.href = '/';
          }}>
            <FaSignOutAlt /> <span className="menuText">Logout</span>
          </li>
        </div>
      </ul>
    </div>
    
  );
}